import moment from 'moment';

export const compareGenderData = (gender: string, genderIntial: string) => {
    if (gender[ 0 ]?.toLowerCase() === genderIntial)
    {
        return true;
    }
}
export const isAgeBelow18 = (dateOfBirth: any) => {
    const minDate: any = moment().subtract(18, 'years');
    if (dateOfBirth > minDate)
        return true;
    return false;
}
export const isKycDone = (status: string) => {
    const arr = [
        'kyc compliant', 'kyc registered', 'kyc registered - new kyc', 'kyc registered - under process', 'kyc registered-new kyc'
    ]
    if (arr.includes(status?.toLowerCase()))
        return true
}
export const isKycNotDone = (status: string) => {
    const arr = [
        'kyc non compliant', 'not available', 'kyc non-compliant'
    ]
    if (arr.includes(status?.toLowerCase()))
        return true
}
export const convertToBlob = (params: any) => {
    fetch(params)
        .then(response => response.blob())
        .then(fileData => {
            return fileData
        })
}
export const compareBusinessTypes = (occupationType: string) => {
    const businessTypes = [ "11", "03", "B", "Business" ]
    if (businessTypes.includes(occupationType))
        return true
}
export const compareServiceTypes = (occupationType: string) => {
    const serviceTypes = [ "01", "02", "04", "10", "Service", "S" ]
    if (serviceTypes.includes(occupationType))
        return true
}
export const compareOtherTypes = (occupationType: string) => {
    const otherTypes = [ "Others", "99", "O", "12", "06", "07", "08" ]
    if (otherTypes.includes(occupationType))
        return true
}

//for masking numbers
export const maskNumbers = (maskingNo: string,trimLength:number) => {
    return (maskingNo.substring(0, trimLength) + maskingNo.substring(trimLength, maskingNo.length - trimLength).replace(/\d/g, 'x') + maskingNo.substring(maskingNo.length - trimLength));
}
